// import axios from "axios";
import apiAnimals from "../config/api_animals";
import apiCommons from "../config/api_commons";
import getHeaders from "./getHeaders";

// const apiAnimals = axios.create({
//   baseURL: "http://localhost:8084",
// });

// const apiCommons = axios.create({
//   baseURL: "http://localhost:8083",
// });

export function getAnimalsWeightHistories(payload) {
  const { groupId, farmId, search, page, size, sort, signal } = payload;

  const orderS =
    Object.entries(sort).length > 0 && sort.order
      ? sort.order === "descend"
        ? "DESC"
        : sort.order === "ascend"
        ? "ASC"
        : "DESC"
      : "DESC";
  const requestParams = `page=${page > 0 ? page - 1 : 0}&size=${size ?? 10}${
    sort && Object.entries(sort).length > 0 && sort.order
      ? `&sort=${sort.field}&direction=${orderS}`
      : ""
  }${search && search !== "" ? `&search=${search}` : ""}`;

  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/animals/weights?${requestParams}`,
    getHeaders(false, signal)
  );
}

export function saveAnimalsWeightHistories(payload) {
  const { groupId, farmId, body, signal } = payload;

  return apiAnimals.post(
    `/bovexo/${groupId}/farms/${farmId}/animals/weights`,
    body,
    getHeaders(false, signal)
  );
}

export function updateAnimalsWeightHistories(payload) {
  const { groupId, farmId, body, id, signal } = payload;

  return apiAnimals.patch(
    `/bovexo/${groupId}/farms/${farmId}/animals/weights/${id}`,
    body,
    getHeaders(false, signal)
  );
}

export function deleteAnimalsWeightHistories(payload) {
  const { groupId, farmId, id, signal } = payload;

  return apiAnimals.delete(
    `/bovexo/${groupId}/farms/${farmId}/animals/weights/${id}`,
    getHeaders(false, signal)
  );
}

export function exportAnimalWeightReport(payload) {
  const { groupId, farmId, body } = payload;

  return apiCommons.post(
    `/bovexo/${groupId}/farms/${farmId}/reports/animals/weights`,
    body,
    getHeaders(false, null, true)
  );
}

export function verifyCanEditAndDelete({ payload }) {
  const { groupId, farmId, id, signal } = payload;

  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/animals/weights/${id}/can-edit-delete`,
    getHeaders(false, signal)
  );
}
